import { Box, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { CommonBody, PaymentResponseType } from "../../types/General";
import {
  GetAgentRevenue,
  useAgentRevenueMutation,
  useSalariedAgentPaymentsMutation,
} from "../../service/payments";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { errorToast } from "../../helpers";
import { isValidInput } from "../../utils/validations";
import { PAYMENT_STATUS_LABELS } from "../../utils/enums";
import { PriceFormatter } from "../../utils/commoFunctions";
import moment from "moment";

type props = {
  id: string | undefined;
  type: string | undefined;
};

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const PaymentHistorySalariedAgent = ({ id }: props) => {
  const navigate = useNavigate();

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) =>
    (currentYear - i).toString()
  );

  const [selectedYear, setSelectedYear] = useState<string>(
    currentYear.toString()
  );

  const handleYearChange = (e: SelectChangeEvent) => {
    setSelectedYear(e.target.value);
  };

  const handleMonth = (e: SelectChangeEvent<number>) => {
    setSelectedMonth(Number(e.target.value));
  };

  const [searchTerm, setSearchTerm] = useState("");

  const [rows, setRows] = useState<PaymentResponseType[]>([]);

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const [agentPayments] = useAgentRevenueMutation();
  const [agentPaymentHistory] = useSalariedAgentPaymentsMutation();
  const [salaryData, setSalaryData] = useState<GetAgentRevenue | null>(null);

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const getAgentPayments = async () => {
    setLoading(true);
    try {
      const body = {
        year: Number(selectedYear),
        month: Number(selectedMonth),
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await agentPayments({
        body: encryptedBody,
        id: Number(id),
      }).unwrap();

      setLoading(false);

      if (response?.status === 200) {
        setSalaryData(response?.data);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const getPaymentHistory = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
        year: Number(selectedYear),
        month: Number(selectedMonth),
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await agentPaymentHistory({
        body: encryptedBody,
        id: Number(id),
      }).unwrap();

      setLoading(false);

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  // const columns: GridColDef<(typeof rows)[number]>[] = [
  //   {
  //     flex: 0.03,
  //     minWidth: 80,
  //     field: "id",
  //     headerName: "S.No",
  //     editable: false,
  //     sortable: false,
  //   },
  //   {
  //     flex: 1,
  //     minWidth: 150,
  //     field: "paymentDate",
  //     headerName: "Payment Date",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <p>22 January 2025</p>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     flex: 1,
  //     minWidth: 150,
  //     field: "applicationId",
  //     headerName: "Application Id",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <p>#WZ-10001</p>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     flex: 1,
  //     minWidth: 300,
  //     field: "applicantDetails",
  //     headerName: "Applicant Details",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <figure onClick={() => navigate("/profile-detail/individual")}>
  //             <img src="/static/images/user_attachment.jpg" alt="" />
  //           </figure>
  //           <p>
  //             <b>Emma Smith</b> +9203024595467 <br />
  //             emma@gmail.com
  //           </p>
  //         </div>
  //       );
  //     },
  //   },
  //   // {
  //   //   flex: 1,
  //   //   minWidth: 150,
  //   //   field: "invoiceNumber",
  //   //   headerName: "Invoice Number",
  //   //   editable: false,
  //   //   sortable: false,
  //   //   renderCell: () => {
  //   //     return (
  //   //       <div className="user_block">
  //   //         <p>WIZ-565744</p>
  //   //       </div>
  //   //     );
  //   //   },
  //   // },
  //   // {
  //   //   flex: 1,
  //   //   minWidth: 150,
  //   //   field: "paymentMode",
  //   //   headerName: "Payment Mode",
  //   //   editable: false,
  //   //   sortable: false,
  //   //   renderCell: () => {
  //   //     return (
  //   //       <div className="user_block">
  //   //         <p>Cash</p>
  //   //       </div>
  //   //     );
  //   //   },
  //   // },
  //   // {
  //   //   flex: 1,
  //   //   minWidth: 150,
  //   //   field: "paymentType",
  //   //   headerName: "Payment Type",
  //   //   editable: false,
  //   //   sortable: false,
  //   //   renderCell: () => {
  //   //     return (
  //   //       <div className="user_block">
  //   //         <p>First</p>
  //   //       </div>
  //   //     );
  //   //   },
  //   // },
  //   {
  //     flex: 1,
  //     minWidth: 150,
  //     field: "firstPayment",
  //     headerName: "First Payment",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <p>$3000</p>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     flex: 1,
  //     minWidth: 150,
  //     field: "firstPaymentCommission",
  //     headerName: "First Payment Commission",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <p>$300</p>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     flex: 1,
  //     minWidth: 150,
  //     field: "secondPayment",
  //     headerName: "Second Payment",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <p>$3000</p>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     flex: 1,
  //     minWidth: 150,
  //     field: "secondPaymentCommission",
  //     headerName: "Second Payment Commission",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <p>$300</p>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     flex: 1,
  //     minWidth: 150,
  //     field: "thirdPayment",
  //     headerName: "Third Payment",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <p>$4000</p>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     flex: 1,
  //     minWidth: 150,
  //     field: "thirdPaymentCommission",
  //     headerName: "Third Payment Commission",
  //     editable: false,
  //     sortable: false,
  //     renderCell: () => {
  //       return (
  //         <div className="user_block">
  //           <p>$400</p>
  //         </div>
  //       );
  //     },
  //   },
  //   // {
  //   //   flex: 1,
  //   //   minWidth: 150,
  //   //   field: "remainingAmount",
  //   //   headerName: "Remaining Amount",
  //   //   editable: false,
  //   //   sortable: false,
  //   //   renderCell: () => {
  //   //     return (
  //   //       <div className="user_block">
  //   //         <p>$20000</p>
  //   //       </div>
  //   //     );
  //   //   },
  //   // },

  //   // {
  //   //   flex: 0.1,
  //   //   minWidth: 80,
  //   //   field: "action",
  //   //   headerName: "Action",
  //   //   editable: false,
  //   //   sortable: false,
  //   //   renderCell: () => {
  //   //     return (
  //   //       <div className="table_actions">
  //   //         <Box>
  //   //           <IconButton
  //   //             aria-controls={open1 ? "basic-menu1" : undefined}
  //   //             aria-haspopup="true"
  //   //             aria-expanded={open1 ? "true" : undefined}
  //   //             onClick={handleClick1}
  //   //           >
  //   //             <img src="/static/images/more_icon.svg" alt="" />
  //   //           </IconButton>
  //   //           <Menu
  //   //             className="setting_menu"
  //   //             id="basic-menu1"
  //   //             anchorEl={anchorEl1}
  //   //             open={open1}
  //   //             onClose={handleClose1}
  //   //             MenuListProps={{
  //   //               "aria-labelledby": "basic-button1",
  //   //             }}
  //   //             PaperProps={{
  //   //               elevation: 0,
  //   //               sx: {
  //   //                 overflow: "visible",
  //   //                 boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
  //   //                 borderRadius: "8px",
  //   //                 mt: 1,
  //   //               },
  //   //             }}
  //   //             transformOrigin={{ horizontal: "right", vertical: "top" }}
  //   //             anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
  //   //           >
  //   //             <MenuItem onClick={() => navigate(`view/${1}`)}>View</MenuItem>
  //   //             <MenuItem onClick={handleClose1}>Delete</MenuItem>
  //   //           </Menu>
  //   //         </Box>
  //   //       </div>
  //   //     );
  //   //   },
  //   // },
  // ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 200,
      field: "paymentDate",
      headerName: "Payment Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.created_at
                ? moment(row?.created_at).format("DD MMM YYYY hh:mm a")
                : "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "applicationId",
      headerName: "Application Id",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.application?.apk_id || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "invoiceId",
      headerName: "Invoice Id",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block" style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
            <p>{row?.payment_id || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "applicantDetails",
      headerName: "User Details",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
              onClick={() => navigate(`/profile-detail/individual/${row?.id}`)}
            >
              <img
                src={
                  row?.user?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{row?.user?.name || "-"}</b> {row?.user?.country_code}{" "}
              {row?.user?.phone_no || "-"} <br />
              {row?.user?.email || "-"}
            </p>
          </div>
        );
      },
    },
    // ...(type === USER_TYPE_SLUGS.COMPANY ||
    // type === USER_TYPE_SLUGS.FREELANCER_AGENT
    //   ? []
    //   : [
    //       {
    //         flex: 1,
    //         minWidth: 300,
    //         field: "applierDetails",
    //         headerName: "Paid to",
    //         editable: false,
    //         sortable: false,
    //         renderCell: ({ row }: GridRenderCellParams<any>) => {
    //           return (
    //             <div className="user_block">
    //               {row?.applier?.email === row?.user?.email ? null : (
    //                 <figure
    //                 // onClick={() =>
    //                 //   navigate(
    //                 //     `/profile-detail/${row?.applier?.user_role_type === 6 ? "company" : "freelancer-agent"}/${row?.id}`
    //                 //   )
    //                 // }
    //                 >
    //                   <img
    //                     src={
    //                       row?.applier?.profile_picture?.media_url ||
    //                       "/static/images/user_placeholder.png"
    //                     }
    //                     alt=""
    //                   />
    //                 </figure>
    //               )}
    //               {row?.applier?.email === row?.user?.email ? (
    //                 <p>ADMIN</p>
    //               ) : (
    //                 <p>
    //                   <b>{row?.applier?.name || "-"}</b>{" "}
    //                   {row?.applier?.country_code}{" "}
    //                   {row?.applier?.phone_no || ""} <br />
    //                   {row?.applier?.email || "-"}
    //                 </p>
    //               )}
    //             </div>
    //           );
    //         },
    //       },
    //     ]),

    // {
    //   flex: 1,
    //   minWidth: 150,
    //   field: "invoiceNumber",
    //   headerName: "Invoice Number",
    //   editable: false,
    //   sortable: false,
    //   renderCell: () => {
    //     return (
    //       <div className="user_block">
    //         <p>WIZ-565744</p>
    //       </div>
    //     );
    //   },
    // },
    {
      flex: 1,
      minWidth: 150,
      field: "paymentMode",
      headerName: "Payment Mode",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.plan_mode?.title || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "paymentType",
      headerName: "Payment Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const partNumber = row?.plan_part_no?.part_number;
        return (
          <div className="user_block">
            <p>
              {partNumber !== null && partNumber !== undefined
                ? PAYMENT_STATUS_LABELS[row?.plan_part_no?.part_number]
                : "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "amountPaid",
      headerName: "Amount Paid",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {PriceFormatter(row?.payment_amt_after_vat?.toString()) || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "vat",
      headerName: "VAT",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{PriceFormatter(row?.vat?.toString()) || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "remainingAmount",
      headerName: "Remaining Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{PriceFormatter(row?.remaining_amt?.toString()) || "-"}</p>
          </div>
        );
      },
    },

    // {
    //   flex: 0.1,
    //   minWidth: 80,
    //   field: "action",
    //   headerName: "Action",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <div className="table_actions">
    //         <Box>
    //           <IconButton
    //             aria-controls={open1 ? "basic-menu1" : undefined}
    //             aria-haspopup="true"
    //             aria-expanded={open1 ? "true" : undefined}
    //             onClick={(event) => handleClick1(event, row?.id)}
    //           >
    //             <img src="/static/images/more_icon.svg" alt="" />
    //           </IconButton>
    //           <Menu
    //             className="setting_menu"
    //             id="basic-menu1"
    //             anchorEl={anchorEl1}
    //             open={open1}
    //             onClose={handleClose1}
    //             MenuListProps={{
    //               "aria-labelledby": "basic-button1",
    //             }}
    //             PaperProps={{
    //               elevation: 0,
    //               sx: {
    //                 overflow: "visible",
    //                 boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
    //                 borderRadius: "8px",
    //                 mt: 1,
    //               },
    //             }}
    //             transformOrigin={{ horizontal: "right", vertical: "top" }}
    //             anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    //           >
    //             <MenuItem onClick={() => navigate(`view/${selectedId}`)}>
    //               View
    //             </MenuItem>
    //           </Menu>
    //         </Box>
    //       </div>
    //     );
    //   },
    // },
  ];
  useEffect(() => {
    getAgentPayments();
  }, []);

  useEffect(() => {
    getPaymentHistory();
  }, [debouncedSearchTerm, page, selectedMonth, selectedYear]);

  return (
    <div className="cards">
      <Box className="custom_tabs" sx={{ width: "100%" }}>
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search"
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>

          <div className="right_s ">
            <div className="control_group w_50">
              <Select
                fullWidth
                labelId="month"
                id="month"
                value={selectedMonth}
                onChange={handleMonth}
              >
                {months?.map((month, index) => (
                  <MenuItem key={index} value={index + 1}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="control_group w_50">
              <Select
                fullWidth
                labelId="year"
                id="year"
                value={selectedYear}
                onChange={handleYearChange}
              >
                <MenuItem disabled value="">
                  Select Year
                </MenuItem>
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        </div>
        <div className="payment-details">
          <div className="paymt w_50">
            <strong>Basic Salary :</strong>
            <span>
              {salaryData?.basic_salary
                ? PriceFormatter(salaryData?.basic_salary?.toString())
                : 0}
            </span>
          </div>
          <div className="paymt w_50">
            <strong>Bonus :</strong>
            <span>
              {salaryData?.bonus
                ? PriceFormatter(salaryData?.bonus?.toString())
                : 0}
            </span>
          </div>
          <div className="paymt w_50">
            <strong>Commission :</strong>
            <span>
              {" "}
              {salaryData?.commission_sum
                ? PriceFormatter(salaryData?.commission_sum?.toString())
                : 0}
            </span>
          </div>
          <div className="paymt w_50">
            <strong>Extra Benefits :</strong>
            <span>
              {salaryData?.benefits
                ? PriceFormatter(salaryData?.benefits?.toString())
                : 0}
            </span>
          </div>
          <div className="paymt w_50">
            <strong>Total :</strong>
            <span>
              {" "}
              {salaryData?.total_salary
                ? PriceFormatter(salaryData?.total_salary?.toString())
                : 0}
            </span>
          </div>
        </div>

        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={rows}
            count={count}
            page={page}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div>
      </Box>
    </div>
  );
};

export default PaymentHistorySalariedAgent;
